var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "van-popup",
    {
      attrs: { "get-container": "body", position: "bottom" },
      model: {
        value: _vm.deptUserTreeAll.show,
        callback: function ($$v) {
          _vm.$set(_vm.deptUserTreeAll, "show", $$v)
        },
        expression: "deptUserTreeAll.show",
      },
    },
    [
      _c("van-nav-bar", {
        attrs: { "left-text": "取消", "right-text": "确定", title: "选择人员" },
        on: { "click-left": _vm.cancel, "click-right": _vm.commentPopupSubmit },
      }),
      _c("van-search", {
        attrs: { clearable: "", shape: "round" },
        on: {
          input: function ($event) {
            return _vm.treeSearch($event, _vm.$refs.tree)
          },
        },
        model: {
          value: _vm.deptUserTreeAll.filterText,
          callback: function ($$v) {
            _vm.$set(_vm.deptUserTreeAll, "filterText", $$v)
          },
          expression: "deptUserTreeAll.filterText",
        },
      }),
      _c(
        "div",
        { staticClass: "h-vh-50", staticStyle: { "overflow-y": "auto" } },
        [
          _c(
            "div",
            { staticClass: "p-10" },
            [
              _c("el-tree", {
                ref: "tree",
                attrs: {
                  data: _vm.deptUserTreeAll.data,
                  "filter-node-method": _vm.filterNode,
                  props: _vm.defaultProps,
                },
                on: { "node-click": _vm.handleNodeClick },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }